import visit from "../../features/visit/visitSlice";
import patientSlice from "../../features/patient/patientSlice";
import authSlice from "../../features/auth/authSlice";
import registrationSlice from "../../features/registration/registrationSlice";
import organizationSlice from "../../features/organization/organizationSlice";
import visitsSlice from "../../features/visits/visitsSlice";
import controllerVisitsSlice from "../../features/controllerVisits/controllerVisitsSlice";
import patientsSlice from "../../features/patients/patientsSlice";
import employeeSlice from "../../features/employee/employeeSlice";
import pendingReducer from "../../features/pending_actions";
import notifications from "../../features/notifications/notificationsSlice";

import { combineReducers } from "@reduxjs/toolkit";
const rootReducer = combineReducers({
  visit: visit,
  visits: visitsSlice,
  controllerVisits: controllerVisitsSlice,
  patient: patientSlice,
  patients: patientsSlice,
  employee: employeeSlice,
  organization: organizationSlice,
  auth: authSlice,
  registration: registrationSlice,
  pendingActions: pendingReducer,
  notifications,
});

export default rootReducer;
